import React from "react";
import ModuleActionsShell from "../shared/ModuleActionsShell";

/** Visual groups only — same action keys/handlers as AttendanceActionsHub. */
export const ATTENDANCE_ACTION_GROUPS = [
  {
    id: "day",
    label: "Day",
    keys: [
      "change_status",
      "change_shift",
      "change_wo",
      "regularise",
      "view_edit_checks",
    ],
  },
  {
    id: "leave",
    label: "Leave",
    keys: [
      "apply_leave",
      "short_leave",
      "leave_adjustment",
      "leave_balance",
      "lop_reversal",
      "comp_off_ledger",
      "restricted_holiday",
    ],
  },
  {
    id: "checks",
    label: "Checks",
    keys: ["on_duty", "overtime"],
  },
];

/**
 * Attendance Actions shell — shared ModuleActionsShell + Day/Leave/Checks groups.
 */
export default function AttendanceActionsFrame({
  actions = [],
  activeKey,
  onSelect,
  icons = {},
  children,
}) {
  void icons;
  return (
    <ModuleActionsShell
      crumbModule="Time & Attendance"
      crumbLeaf="Actions"
      title="Attendance actions"
      subtitle="Fix a day, a shift or a leave for one employee at a time."
      groups={ATTENDANCE_ACTION_GROUPS}
      actions={actions}
      activeKey={activeKey}
      onSelect={onSelect}
    >
      {children}
    </ModuleActionsShell>
  );
}
